<template>
  <div class="approve-drawer_content">
    <el-form
      :model="approvalFormData"
      ref="approvalFormData"
      label-width="100px"
      label-position="top"
      style="text-align:left;"
    >
      <!-- 审批人选项 -->
      <el-form-item>
        <el-radio-group v-model="approvalFormData.type" @change="changeApproverOptions">
          <el-radio
            v-for="item in approvalTypesCanSelect"
            :key="item.id"
            :label="item.itemCode"
            class="approve-radio"
          >{{item.itemName}}</el-radio>
        </el-radio-group>
      </el-form-item>

      <!-- 说明 -->
      <el-divider></el-divider>
      <p style="font-size:14px;line-height:30px;">{{approveOptionsNote}}</p>

      <el-divider></el-divider>

      <!-- 主管 -->
      <manager
        v-show="judgeApprovalOptionType('supervisor')"
        :approvalData="approvalFormData"
        ref="manager"
      />

      <!-- 选择人员 -->
      <p v-if="selectEmployeeWidget">
        <span class="item-label">{{selectEmployeeWidget.label}}</span>
        <select-people
          @byEmployee="setEmployees"
          @byDepartment="setDepartment"
          :defaultVal="defaultSelected"
          :defaultShowText="selectEmployeeWidget.buttonText"
          :onlySelectEmployee="selectEmployeeWidget.onlySelectEmployee"
          v-if="selectEmployeeStatus"
          disabledSelectAll
        ></select-people>
      </p>

      <el-checkbox
        v-model="approvalFormData.containChildDepartment"
        v-if="showContainChildDepartment"
      >包含子部门</el-checkbox>

      <!-- 选择角色 -->
      <p v-show="judgeApprovalOptionType('role')">
        <span class="item-label">角色：</span>
        <select-roles-by-drop-down ref="selectRoles" @byRoles="setRoleRange" multiple></select-roles-by-drop-down>
      </p>

      <!-- 多人审批 -->
      <p v-show="isShowSelectSignType">
        <el-divider></el-divider>
        <el-form-item label="多人审批时采用的审批方式">
          <el-radio-group v-model="approvalFormData.signType">
            <el-radio
              v-for="item in signTypes"
              :key="item.code"
              :label="item.code"
              class="approve-radio"
            >{{item.label}}</el-radio>
          </el-radio-group>
        </el-form-item>
      </p>

      <!-- 找不到审批人 -->
      <div v-show="!judgeApprovalOptionType('presetEmployee')">
        <el-divider></el-divider>
        <el-form-item label="找不到审批人时：">
          <el-radio-group v-model="approvalFormData.notFindApprover">
            <el-radio
              v-for="item in notFindApproverOptions"
              :key="item.id"
              :label="item.itemCode"
              class="approve-radio"
            >{{item.itemName}}</el-radio>
          </el-radio-group>
        </el-form-item>
      </div>
    </el-form>
  </div>
</template>

<script>
import SelectRolesByDropDown from "@/components/business/selectRoles/SelectRolesByDropDown";
import Manager from "./modules/manager";

import {
  initNodeForm,
  signTypes,
  selectEmployeeWidgetConfigs,
  showSelectSignType,
  signTypesList,
  getApprovalTypeDescribe,
  approvalTypesCanSelect,
  operatorSelectTypes
} from "./approvalConfig";

export default {
  components: {
    SelectRolesByDropDown,
    Manager
  },

  props: {
    currentEditNode: {
      type: Object
    },
    moddle: {
      type: Object
    },
    notFindApproverOptions: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },

  computed: {
    approvalTypesCanSelect() {
      return approvalTypesCanSelect(
        this.approvalOptionEnum,
        this.currentEditNode.id
      );
    },

    approveOptionsNote() {
      return getApprovalTypeDescribe(this.approvalFormData.type);
    },

    selectEmployeeWidget() {
      return selectEmployeeWidgetConfigs.find(
        item => this.approvalFormData.type === item.type
      );
    },

    showContainChildDepartment() {
      return this.approvalFormData.departmentRange.length;
    },

    isShowSelectSignType() {
      return showSelectSignType(
        this.approvalFormData.type,
        this.approvalFormData.employeeRange
      );
    },

    signTypes() {
      return signTypesList(this.currentEditNode.id, this.approvalFormData.type);
    },

    defaultSelected() {
      return this.defaultEmployees.concat(this.defaultDepartments);
    }
  },

  data() {
    return {
      selectEmployeeStatus: true,
      operatorSelectTypes: operatorSelectTypes,
      approvalFormData: this.$js.deepClone(initNodeForm.Approver),
      defaultEmployees: [],
      defaultDepartments: [],

      approvalOptionEnum: []
    };
  },

  created() {
    this.setApprovalOptionEnum("approvalOption");
  },

  methods: {
    setApprovalOptionEnum(enumCode) {
      this.$api.enumTypeCode(enumCode).then(res => {
        this.approvalOptionEnum = res;
      });
    },

    //切换审批人的类型
    changeApproverOptions(type) {
      this.resetApprovalFormData();
      this.resetSelectWidget();
      this.approvalFormData.type = type;
    },

    // 重置选择雇员、选择角色组件
    resetSelectWidget() {
      this.resetSelectEmployee();
      this.resetSelectedRole();
    },

    judgeApprovalOptionType(type) {
      return this.approvalFormData.type === type;
    },

    //根据枚举id判断其枚举code

    /**
     * 重置数据
     *
     */
    resetApprovalFormData() {
      this.approvalFormData = this.$js.deepCopyObj(initNodeForm.Approver);
    },

    resetSelectEmployee() {
      this.defaultEmployees = [];
      this.defaultDepartments = [];
      this.selectEmployeeStatus = false;
      this.$nextTick(() => {
        this.selectEmployeeStatus = true;
      });
    },

    resetSelectedRole() {
      this.$refs.selectRoles.selectedRoleIds = [];
    },

    setEmployees(employees) {
      this.approvalFormData.employeeRange = employees.map(item => ({
        id: item.id,
        employeeName: item.name
      }));
    },

    setDepartment(departments) {
      this.approvalFormData.departmentRange = departments.map(item => ({
        id: item.id,
        departmentName: item.name
      }));
    },

    setRoleRange(roles) {
      var selectedRoles = roles || [];
      this.approvalFormData.roleRange = selectedRoles.map(item => ({
        id: item.id,
        roleName: item.roleName
      }));
    },

    setApprovalFormData(formData, employees, departments, roleRange) {
      this.approvalFormData = this.$js.deepCopyObj(formData);
      this.defaultEmployees = employees.map(item => ({
        id: item.id,
        name: item.employeeName,
        type: 1
      }));
      this.defaultDepartments = departments.map(item => ({
        id: item.id,
        name: item.departmentName,
        type: 0
      }));
      this.$refs.selectRoles.selectedRoleIds = roleRange.map(
        item => item && item.id
      );
    },

    initFormData(initData) {
      this.setApprovalFormData(
        initData,
        initData.employeeRange,
        initData.departmentRange || [],
        initData.roleRange
      );
    },

    createdBpmnSetting() {
      this.currentEditNode.set("flowable:assignee", "${userSign}");
      this.createBpmnDataByMultiple(
        this.approvalFormData.signType,
        this.currentEditNode
      );
    },

    getShowText() {
      if (this.approvalFormData.type === "initiatorAssignee") {
        return operatorSelectTypes.find(
          item => item.code === this.approvalFormData.selfSelectType
        ).label;
      }

      if (this.approvalFormData.type === "supervisor") {
        return "部门主管";
      }

      let signType = signTypes.find(
        item => item.code === this.approvalFormData.signType
      ).label;

      if (this.approvalFormData.type === "role") {
        let roleName = this.approvalFormData.roleRange
          .map(item => item.roleName)
          .join();

        return roleName + "进行" + signType;
      }

      if (this.approvalFormData.type === "presetEmployee") {
        let employeeName = this.approvalFormData.employeeRange
          .map(item => item.employeeName)
          .join();

        if (this.approvalFormData.employeeRange.length > 1) {
          return employeeName + signType;
        }
        return employeeName;
      }
      return "";
    },

    getDocument() {
      Object.assign(this.approvalFormData, this.$refs.manager.requestFormData);
      return this.approvalFormData;
    },

    createBpmnDataByMultiple(signType, bpmnNode) {
      if (signType === "sequentialSign") {
        this.setMultiInstance(bpmnNode, bpmnNode.id, "true");
      } else {
        this.setMultiInstance(bpmnNode, bpmnNode.id, "false");
      }

      if (signType === "andSign") {
        this.setCompletionCondition(
          bpmnNode.loopCharacteristics,
          "${nrOfCompletedInstances/nrOfInstances >= 1}"
        );
      }
      if (signType === "orSign") {
        this.setCompletionCondition(
          bpmnNode.loopCharacteristics,
          "${nrOfCompletedInstances == 1}"
        );
      }
    },

    /**
     * bpmn XML 设置
     */

    setMultiInstance(bpmnNode, id, isSequential) {
      var loopCharacteristics = this.moddle.create(
        "bpmn:MultiInstanceLoopCharacteristics"
      );
      loopCharacteristics.set("isSequential", isSequential);
      loopCharacteristics.set("flowable:elementVariable", "userSign");
      loopCharacteristics.set("flowable:collection", id);
      bpmnNode.loopCharacteristics = loopCharacteristics;
    },

    setCompletionCondition(bpmnNode, bodyValue) {
      var completionCondition = this.moddle.create("bpmn:FormalExpression", {
        body: bodyValue
      });
      bpmnNode.completionCondition = completionCondition;
    },

    clearBpmnSetting(bpmnNode) {
      delete bpmnNode.documentation;
      delete bpmnNode.loopCharacteristics;
      delete bpmnNode["flowable:assignee"];
      delete bpmnNode["flowable:candidateUsers"];
    }
  }
};
</script>

<style scoped>
::v-deep .ivu-modal-wrap {
  z-index: 100000 !important;
}

.approve-radio {
  height: 40px;
  line-height: 40px;
}

.item-label {
  float: left;
  line-height: 40px;
  height: 40px;
  font-size: 14px;
  margin-right: 20px;
}
</style>